import { useQuery } from '@tanstack/react-query';
import GeospatialQueries, { GEOSPATIAL_QUERY_KEYS } from '../query';

export const useReverseGeocode = (location: string, local: boolean) => {
  return useQuery({
    queryKey: [GEOSPATIAL_QUERY_KEYS.REVERSE_GEOCODE, location, local],
    queryFn: () => GeospatialQueries.reverseGeocode(location, local),
    enabled: !!location,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
